import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'antd';
import * as ModalStore from '../../stores/modals';
import { BUTTON } from '../../configureHIS/common/constants';
import HeaderModal from '../../configureHIS/common/headerModal';

class ErrorMessageModal extends React.Component {
    componentDidMount() {
        document.addEventListener('keydown', (e) => {
            if (e.key === "Enter")
                this.onCancel();
        });
    }
    componentWillUnmount() {
        document.removeEventListener('keydown');
    }
    onCancel() {
        if (this.props.closeError())
            this.props.closeError();
    }
    render() {

        let { modal } = this.props;
        let { errContent } = modal;
        let modalHeaderProps = {
            title: modal ? modal.errHeader : '',
            ...(modal.closeable && { onClose: () => this.onCancel() })
        }

        return (
            <Modal maskClosable={false} visible={modal ? modal.errModal : false} closable={false} zIndex={999999}
                cancelButtonProps={{ style: { display: 'none' } }}
                footer={null} style={{ zIndex: 999999 }} width={800}
                okButtonProps={{ style: { display: 'none' } }}>
                <div style={{
                    width: '100%', color: '#293555',
                    flexDirection: 'column', fontSize: '11px',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'auto'
                }}>
                    <div className='w-100'>
                        <HeaderModal {...modalHeaderProps} />
                    </div>
                    <div style={{
                        margin: 'auto',
                        flex: '1 1 auto',
                        overflow: 'auto',
                    }}>
                        <div style={{
                            borderBottom: '1px solid rgb(232,232,232)',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: '16px',
                        }}
                            dangerouslySetInnerHTML={{ __html: `${errContent}` }}
                        >
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '40px',
                    }}>
                        {modal.closeable && <button className={BUTTON.DANGER}
                            onClick={() => { this.onCancel() }}><i className="fas fa-sign-out-alt mr-1"/>Đóng</button>}
                    </div>
                </div>
            </Modal>

        );
    }
}
const mapStateToProps = (state) => ({
    modal: state.modal,
});
export default connect(
    mapStateToProps,
    ModalStore.actions
)(ErrorMessageModal);